// Demo users for demonstration purposes
// These users are only returned when the app is in demo mode (checked via BaseApi.isDemo())
// Regular users will still fetch real data from the backend

export const DEMO_USERS = [
  {
    id: 1,
    firstName: 'John',
    lastName: 'Smith',
    email: 'john.smith@seoplus.ca',
    userType: 2, // DEMO user type
    avatar: '/logo.jpg', // seoplus logo
    company: 'seoplus+',
    position: 'PR Specialist',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-10-26T12:00:00Z',
  },
  {
    id: 5,
    firstName: 'Julie',
    lastName: 'Anderson',
    email: 'julie.anderson@seoplus.ca',
    userType: 2, // DEMO user type
    avatar: '/logo.jpg', // seoplus logo
    company: 'seoplus+',
    position: 'PR Specialist',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-10-26T12:00:00Z',
  },
  {
    id: 6,
    firstName: 'Michael',
    lastName: 'Chen',
    email: 'michael.chen@seoplus.ca',
    userType: 2, // DEMO user type
    avatar: '/logo.jpg', // seoplus logo
    company: 'seoplus+',
    position: 'PR Specialist',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-10-26T12:00:00Z',
  },
  {
    id: 9,
    firstName: 'Sarah',
    lastName: 'Johnson',
    email: 'sarah.johnson@seoplus.ca',
    userType: 2, // DEMO user type
    avatar: '/logo.jpg', // seoplus logo
    company: 'seoplus+',
    position: 'PR Manager',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-10-26T12:00:00Z',
  },
];
